/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GlobalOptOut } from './GlobalOptOut';
import {
    GlobalOptOutFromJSON,
    GlobalOptOutFromJSONTyped,
    GlobalOptOutToJSON,
} from './GlobalOptOut';

/**
 * 
 * @export
 * @interface CreateEmailOptOut200Response
 */
export interface CreateEmailOptOut200Response {
    /**
     * 
     * @type {GlobalOptOut}
     * @memberof CreateEmailOptOut200Response
     */
    data: GlobalOptOut;
}

/**
 * Check if a given object implements the CreateEmailOptOut200Response interface.
 */
export function instanceOfCreateEmailOptOut200Response(value: object): value is CreateEmailOptOut200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateEmailOptOut200ResponseFromJSON(json: any): CreateEmailOptOut200Response {
    return CreateEmailOptOut200ResponseFromJSONTyped(json, false);
}

export function CreateEmailOptOut200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmailOptOut200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': GlobalOptOutFromJSON(json['data']),
    };
}

export function CreateEmailOptOut200ResponseToJSON(value?: CreateEmailOptOut200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': GlobalOptOutToJSON(value['data']),
    };
}

